/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 02.08.2016.
 */

import {PendingState, SuccessState, ErrorState} from '../../utils';
import {GET_PARENTAL_STATE, HIDE_ADULT_CONTENT, SHOW_ADULT_CONTENT, PIN_CHANGE} from '../../actions/parental/actions-parental';

const INIT_STATE = {
  state: lh.common.parental,
  inProgress: false,
  isSuccess: false,
  isError: false,
  isReloadNeeded: false,
  errorMsg: ''
};

export default function (state = INIT_STATE, action) {

  switch (action.type) {
    case GET_PARENTAL_STATE:
      return {...state, state: action.payload};

    case PendingState(HIDE_ADULT_CONTENT):
      return {...state, inProgress: true, isError: false, isSuccess: false, errorMsg: ''};

    case SuccessState(HIDE_ADULT_CONTENT):
      return {...state, inProgress: false, isError: false, isSuccess: true, errorMsg: '', isReloadNeeded: true};

    case ErrorState(HIDE_ADULT_CONTENT):
      return {...state, inProgress: false, isError: true, isSuccess: false, errorMsg: action.payload.message};

    case PendingState(SHOW_ADULT_CONTENT):
      return {...state, inProgress: true, isError: false, isSuccess: false, errorMsg: ''};

    case SuccessState(SHOW_ADULT_CONTENT):
      return {...state, inProgress: false, isError: false, isSuccess: true, errorMsg: '', isReloadNeeded: true};

    case ErrorState(SHOW_ADULT_CONTENT):
      return {...state, inProgress: false, isError: true, isSuccess: false, errorMsg: action.payload.message};

    case PendingState(PIN_CHANGE):
      return {...state, inProgress: true, isError: false, isSuccess: false, errorMsg: ''};

    case SuccessState(PIN_CHANGE):
      return {...state, inProgress: false, isError: false, isSuccess: true, errorMsg: ''};

    case ErrorState(PIN_CHANGE):
      return {...state, inProgress: false, isError: true, isSuccess: false, errorMsg: action.payload.message};

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/parental/reducer-parental.js